import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { DraggableModalDialog } from './DraggableModalDialog';

const DismissableModal = forwardRef((props, ref) => {
  const {
    initialStateOpen,
    onComponentUpdated,
    onClose,
    onShow,
    openModalButton,
    openModalButtonStyle,
    openModalButtonSize,
    openModalButtonBlock,
    openModalButtonDisabled,
    openModalButtonId,
    openModalButtonClassName,
    openModalButtonTestId,
    openModalButtonIcon,
    openModalButtonText,
    modalId,
    customModalStyle,
    size,
    modalClassName,
    preventCloseWhenClickedOutsideModal,
    keyboard,
    enforceFocus = true,
    draggable,
    centered,
    title,
    children,
    hideFooter,
    customFooterContent
  } = props;

  const [show, setShow] = useState(initialStateOpen || false);

  useEffect(() => {
    if (onComponentUpdated && typeof onComponentUpdated === 'function') {
      onComponentUpdated();
    }
  }, [onComponentUpdated]);

  const handleClose = (event = null) => {
    setShow(false);
    if (onClose && typeof onClose === 'function') {
      onClose();
    }
  };

  const handleShow = () => {
    setShow(true);
    if (onShow && typeof onShow === 'function') {
      onShow();
    }
  };

  // Expose handleShow and handleClose methods via ref for backward compatibility
  useImperativeHandle(ref, () => ({
    handleShow,
    handleClose
  }));

  return (
    <>
      {openModalButton === undefined
        ? <Button
            onClick={handleShow}
            variant={openModalButtonStyle ? openModalButtonStyle : "info"}
            size={openModalButtonSize ? openModalButtonSize : null}
            disabled={openModalButtonDisabled}
            id={openModalButtonId}
            className={
              [
                openModalButtonClassName || "",
                openModalButtonBlock ? "btn-block w-100" : "",
              ]
                .filter(Boolean)
                .join(" ") || undefined
            }
            data-testid={openModalButtonTestId ? openModalButtonTestId : ''}
          >
            {openModalButtonIcon ? openModalButtonIcon : null}
            {openModalButtonText ? openModalButtonText : null}
          </Button>
        : openModalButton
      }

      <Modal
        id={"modal " + (modalId ? modalId : "")}
        show={show}
        onHide={handleClose}
        style={customModalStyle}
        size={size !== undefined ? size : null}
        dialogClassName={modalClassName}
        backdrop={preventCloseWhenClickedOutsideModal ? 'static' : true}
        keyboard={keyboard !== undefined ? keyboard : true}
        enforceFocus={enforceFocus}
        dialogAs={draggable !== false ? DraggableModalDialog : undefined}
        centered={centered}
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         {children}
        </Modal.Body>
        {
          hideFooter
          ? null
          : <Modal.Footer>
            {
              customFooterContent !== undefined
              ? customFooterContent
              : <Button onClick={handleClose} variant="outline-dark" >Close</Button>
            }
            </Modal.Footer>
        }
      </Modal>
    </>
  );
});

export default DismissableModal;
